import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { api } from '../api/client.js';
import { LANGUAGES, setLanguage, toLanguage, type Language } from '../i18n.js';
import { ME_KEY } from '../session.js';

/** Changes the UI language; signed-in users keep it for app and e-mails. */
export function LanguageSwitch({ signedIn }: { signedIn: boolean }) {
  const { t, i18n } = useTranslation();
  const client = useQueryClient();
  const change = async (language: Language) => {
    setLanguage(language);
    if (signedIn) {
      await api.PATCH('/me', { body: { locale: language } });
      await client.invalidateQueries({ queryKey: ME_KEY });
    }
  };
  return (
    <div className="flex items-center gap-2">
      <label htmlFor="language" className="sr-only">
        {t('nav.language')}
      </label>
      <select
        id="language"
        value={toLanguage(i18n.language)}
        onChange={(e) => void change(e.target.value as Language)}
        className="min-h-11 rounded-md border border-slate-400 bg-white px-2 py-1"
      >
        {LANGUAGES.map((l) => (
          <option key={l} value={l} lang={l}>
            {t(`lang.${l}`)}
          </option>
        ))}
      </select>
    </div>
  );
}
